import { useEffect, useState, useRef } from 'react'
import { useContext } from 'use-context-selector'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Context as ScrollbarContext } from '@/context/scrollbar'

const useInView = ({
  start = 'top center',
  end = 'bottom center',
  once = true,
  trigger = null,
}) => {
  const [isInView, setInView] = useState(false)
  const { scrollElement } = useContext(ScrollbarContext)
  const triggerRef = useRef()

  useEffect(() => {
    if (scrollElement) {
      triggerRef.current = ScrollTrigger.create({
        scroller: scrollElement,
        trigger,
        start,
        end,
        once,
        onEnter: () => setInView(true),
        onEnterBack: () => setInView(true),
        onLeave: () => setInView(false),
      })
    }
    return () => {
      if (triggerRef.current) triggerRef.current.kill()
    }
  }, [scrollElement, trigger])

  return { isInView }
}

export default useInView
